import { defineStore } from "pinia";
import Services from '@/services/personServices'

export const useMartyrSacrificeStore = defineStore("martyr", {

state:()=>({
    martyrSacrifice: {},
    martyrSacrificers: [],
}),
getters : {
    getMartyrSacrifice() {
        return this.martyrSacrifice
    },
    getMartyrSacrificers() {
        return this.martyrSacrificers
    }
},
actions : {
    /** Start Sets */
    setMartyrSacrifice(martyrSacrifice) {
        this.martyrSacrifice = martyrSacrifice
    },
    setMartyrSacrificers(martyrSacrificers) {
        this.martyrSacrificers = martyrSacrificers
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setMartyrSacrifice(response.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setMartyrSacrificers(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.martyrSacrificers.push(response.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.martyrSacrificers[this.martyrSacrificers.findIndex((x)=>x.id == id)] = response.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.martyrSacrificers = this.martyrSacrificers.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});